import { render, staticRenderFns } from "./officials-icon.vue?vue&type=template&id=17adf608"
import script from "./officials-icon.vue?vue&type=script&lang=js"
export * from "./officials-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports